"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = processSort;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _getalreadyrendered = _interopRequireDefault(require("./getalreadyrendered"));

var _foreach = _interopRequireDefault(require("../../_helpers/foreach"));

// this function gets called when array is sorted (via sort, orderBy or reverse)
function processSort(_ref) {
  var self = _ref.self,
      selfDef = _ref.selfDef,
      container = _ref.container;
  // just re-insert rendered nodes in new order
  (0, _foreach["default"])(self, function (item) {
    if (item && (0, _typeof2["default"])(item) === 'object') {
      var node = (0, _getalreadyrendered["default"])({
        item: item,
        selfDef: selfDef
      });

      if (node) {
        container.appendChild(node);
      }
    }
  });
}
//# sourceMappingURL=processsort.js.map